import { c as _c } from "react/compiler-runtime";
import { AnalyticsProvider as BaseAnalyticsProvider } from '@newfront-insurance/data-layer-client';
import type { AuthProviderContext, AuthProviderProps } from '@newfront-insurance/next-auth';
import type { Provider } from '@newfront-insurance/react-provision';
import type { ConfigType } from '@newfront-insurance/shared-public-config';
import { useMemo, type JSX } from 'react';
import * as React from 'react';
import { useIsCsa } from '../hooks/use-is-csa';
import { useIsEngineer } from '../hooks/use-is-engineer';
import { useIsGrowthCaller } from '../hooks/use-is-growth-caller';
import { useIsProducer } from '../hooks/use-is-producer';
import { useLoggedInUser } from '../hooks/use-logged-in-user';
import { useIsAccountManager } from '../hooks/useIsAccountManager';
interface Props {
  children: React.ReactNode;
  authProvider: Provider<AuthProviderContext, AuthProviderProps>;
  config: ConfigType;
  analyticsAppName: string;
}
export function AnalyticsProvider(t0) {
  const $ = _c(16);
  const {
    children,
    authProvider,
    config,
    analyticsAppName
  } = t0;
  const user = useLoggedInUser(authProvider);
  const {
    SEGMENT
  } = config;
  const isCsa = useIsCsa(authProvider);
  const isProducer = useIsProducer(authProvider);
  const isGrowthCaller = useIsGrowthCaller(authProvider);
  const isEngineer = useIsEngineer(authProvider);
  const isAccountManager = useIsAccountManager(authProvider);
  let t1;
  bb0: {
    if (!user) {
      t1 = undefined;
      break bb0;
    }
    const t2 = !isEngineer && isAccountManager;
    const t3 = !isEngineer && isCsa;
    const t4 = !isEngineer && isGrowthCaller;
    const t5 = !isEngineer && isProducer;
    let t6;
    if ($[0] !== isEngineer || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== user.email) {
      t6 = {
        email: user.email,
        isAccountManager: t2,
        isCsa: t3,
        isGrowthCaller: t4,
        isProducer: t5,
        isTechTeam: isEngineer
      };
      $[0] = isEngineer;
      $[1] = t2;
      $[2] = t3;
      $[3] = t4;
      $[4] = t5;
      $[5] = user.email;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    let t7;
    if ($[7] !== t6 || $[8] !== user.uuid) {
      t7 = {
        userId: user.uuid,
        traits: t6
      };
      $[7] = t6;
      $[8] = user.uuid;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    t1 = t7;
  }
  const userDetails = t1;
  let t2;
  if ($[10] !== SEGMENT.SOURCES.ADMIN_DASH || $[11] !== analyticsAppName || $[12] !== authProvider || $[13] !== children || $[14] !== userDetails) {
    t2 = <BaseAnalyticsProvider apiKey={SEGMENT.SOURCES.ADMIN_DASH} user={userDetails} authProvider={authProvider} appName={analyticsAppName} heartbeatsEnabled={process.env.NODE_ENV === "production"}>{children}</BaseAnalyticsProvider>;
    $[10] = SEGMENT.SOURCES.ADMIN_DASH;
    $[11] = analyticsAppName;
    $[12] = authProvider;
    $[13] = children;
    $[14] = userDetails;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  return t2;
}